import localeModule from 'timeago.js/lib/lang/pl'
const localeName = 'pl'
export default { locale: localeName, module: localeModule }
